import { observer } from "mobx-react-lite";

import { usePSPSettingState } from "./form.state";
import { PSPSettingView } from "./form.view";

export type PSPSettingProps = {
  entity: { agentId: number } | { clientId: number } | { hallId: number };
  readonly?: boolean;
};

export const PSPSetting = observer<PSPSettingProps>((props) => {
  const state = usePSPSettingState(props);
  return <PSPSettingView state={state} readonly={props.readonly} />;
});
